import { render, staticRenderFns } from "./BillingTicketTabModal.vue?vue&type=template&id=23e6f4fb&scoped=true&"
import script from "./BillingTicketTabModal.vue?vue&type=script&lang=js&"
export * from "./BillingTicketTabModal.vue?vue&type=script&lang=js&"
import style0 from "./BillingTicketTabModal.vue?vue&type=style&index=0&id=23e6f4fb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e6f4fb",
  null
  
)

export default component.exports